// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"289":"50230384","368":"60ca2518","420":"94b5b80c","454":"01fbdf0e","601":"4f4ef97e","871":"3648e2e1","941":"de69ab51"}[chunkId] + ".chunk.css";
};